import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import Loader from "components/common/loader/Loader";

import { useParams } from "react-router-dom";
import { validateUser } from "services/UserManagementServices";
import { useTranslation } from "react-i18next";
const ValidateUser = () => {
  const { t } = useTranslation();
  const [invalidToken, setInvalidToken] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const userValidation = async () => {
      let result = await validateUser(id);
      if (result?.success) {
        localStorage.setItem("userId", id);
        setTimeout(() => {
          window.location = "/create-password";
        }, 1500);
      } else if (result.status === 422) {
        setInvalidToken(true);
      } else {
        toast.error(t("err-user-validation"));
      }
    };
    userValidation();
  }, []);

  return (
    <>
      <div
        className="d-flex justify-content-center align-items-center w-100"
        style={{ height: "100vh" }}
      >
        {invalidToken ? (
          <div className="d-flex justify-content-center align-items-center flex-column">
            <img src={"/assets/icons/expiredicon.png"} />
            <h4 className="fw-bold">{t("link-expired")}</h4>
          </div>
        ) : (
          <div className="text-center">
            <Loader />
            <h5 className="mt-4">{t("loading")}</h5>
          </div>
        )}
      </div>
    </>
  );
};

export default ValidateUser;
